import BiometricStaffManagerContainer from "../../container/admin/biometric-staff-manager/BiometricStaffManagerContainer";

const BiometricStaffManager = () => {
    return <BiometricStaffManagerContainer />;
};

export default BiometricStaffManager;
